import { callApi } from '../../../../../../apiCaller';
import { cloneDeep, toastError } from '../../../../../../utils';
import { toast } from 'react-toastify';
import {
     setIsLoading,
     setIsWaiting,
     setIsWaitingOrder,
     setRemoveLoading,
     setShowEditPopup,
     setShowPopup,
     setShowPopupDetail,
     setShowRemovePopup,
} from '../../../../../../actions/general';
import {
     API_SYSTEM_ADMIN_LESSON,
     API_SYSTEM_ADMIN_LESSONS,
     API_SYSTEM_ADMIN_LESSON_ORDER_DOWN,
     API_SYSTEM_ADMIN_LESSON_ORDER_UP,
     API_SYSTEM_ADMIN_PREREQUISITE,
     API_SYSTEM_ADMIN_PRODUCT_DETAILS,
     API_SYSTEM_ADMIN_PRODUCT_EVENT,
     API_SYSTEM_ADMIN_PRODUCT_EVENTS,
     API_SYSTEM_ADMIN_PRODUCT_EVENT_CONFIRM_ATTENDEES,
     API_SYSTEM_ADMIN_PRODUCT_INSTRUCTORS,
     API_SYSTEM_ADMIN_PRODUCT_INSTRUCTOR_ORDER,
     API_SYSTEM_ADMIN_PRODUCT_MEDIA,
     API_SYSTEM_ADMIN_PRODUCT_MEDIAS,
     API_SYSTEM_ADMIN_PRODUCT_REVIEW,
     API_SYSTEM_ADMIN_PRODUCT_REVIEWS,
     API_SYSTEM_ADMIN_PRODUCT_FAQ,
     API_SYSTEM_ADMIN_PRODUCT_FAQS,
     INSTRUCTOR_DEFAULT,
     API_SYSTEM_ADMIN_PRODUCT_FAQ_ORDER_UP,
     API_SYSTEM_ADMIN_PRODUCT_FAQ_ORDER_DOWN,
     API_SYSTEM_ADMIN_PRODUCT_EVENT_CLONE,
     API_SYSTEM_ADMIN_UPDATED_WITH_ASSIGN_ORGANIZATIONS,
     DEFAULT_FN,
} from '../../../../../../constants';

export const SET_ADMIN_PRODUCT_DETAILS = 'setAdminProductDetails';
export const ADD_ADMIN_PRODUCT_REVIEW = 'addAdminProductReview';
export const UPDATE_ADMIN_PRODUCT_REVIEW = 'updateAdminProductReview';
export const DELETE_ADMIN_PRODUCT_REVIEW = 'deleteAdminProductReview';
export const ADD_ADMIN_PRODUCT_MEDIA = 'addAdminProductMedia';
export const UPDATE_ADMIN_PRODUCT_MEDIA = 'updateAdminProductMedia';
export const DELETE_ADMIN_PRODUCT_MEDIA = 'deleteAdminProductMedia';
export const ADD_ADMIN_PRODUCT_INSTRUCTOR_LEADER = 'addAdminProductInstructorLeader';
export const SET_ADMIN_PRODUCT_PREREQUISITE = 'setAdminProductPrerequisite';
export const ADD_ADMIN_LESSON = 'addAdminLesson';
export const UPDATE_ADMIN_LESSON = 'updateAdminLesson';
export const DELETE_ADMIN_LESSON = 'deleteAdminLesson';
export const ADD_ADMIN_PRODUCT_EVENT = 'addAdminProductEvent';
export const UPDATE_ADMIN_PRODUCT_EVENT = 'updateAdminProductEvent';
export const DELETE_ADMIN_PRODUCT_EVENT = 'deleteAdminProductEvent';
export const ADD_ADMIN_PRODUCT_FAQ = 'addAdminProductFAQ';
export const UPDATE_ADMIN_PRODUCT_FAQ = 'updateAdminProductFAQ';
export const DELETE_ADMIN_PRODUCT_FAQ = 'deleteAdminProductFAQ';

// Product Details
export const setAdminProductDetails = (productDetails) => {
     return {
          type: SET_ADMIN_PRODUCT_DETAILS,
          payload: productDetails,
     };
};

export const fetchAdminProductDetailsRequest =
     (productId, setupProductData = DEFAULT_FN) =>
     async (dispatch) => {
          dispatch(setIsLoading(true));

          return await callApi(API_SYSTEM_ADMIN_PRODUCT_DETAILS.replace(':id', productId), 'GET')
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    const newProductDetails = response.data;

                    dispatch(setAdminProductDetails(newProductDetails));
                    setupProductData(newProductDetails);

                    return newProductDetails;
               })
               .finally(() => {
                    dispatch(setIsLoading(false));
               });
     };

// Product Review
export const addAdminProductReview = (productReview) => {
     return {
          type: ADD_ADMIN_PRODUCT_REVIEW,
          payload: productReview,
     };
};

export const updateAdminProductReview = (productReview) => {
     return {
          type: UPDATE_ADMIN_PRODUCT_REVIEW,
          payload: productReview,
     };
};

export const deleteAdminProductReview = (productReviewId) => {
     return {
          type: DELETE_ADMIN_PRODUCT_REVIEW,
          payload: productReviewId,
     };
};

export const addAdminProductReviewRequest = (productId, productReview) => (dispatch, getState) => {
     const user = getState().subscriber.user;

     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_REVIEWS.replace(':id', productId), 'POST', productReview)
          .then((response) => {
               if (response.status === 200) {
                    const newReview = response.data.review;
                    const _newReview = {
                         ...newReview,
                         users: {
                              firstName: user.firstName,
                              lastName: user.lastName,
                         },
                    };
                    dispatch(addAdminProductReview(_newReview));
                    dispatch(setShowPopup());
                    toast.success('Created Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const updateAdminProductReviewRequest = (productId, productReview) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_REVIEW.replace(':id', productId).replace(':reviewId', productReview.id), 'PUT', productReview)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(updateAdminProductReview(response.data.review));
                    dispatch(setShowPopupDetail(null));
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const deleteAdminProductReviewRequest = (productId, productReviewId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_REVIEW.replace(':id', productId).replace(':reviewId', productReviewId), 'DELETE')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(deleteAdminProductReview(productReviewId));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

// Product Media
export const addAdminProductMedia = (productMedia) => {
     return {
          type: ADD_ADMIN_PRODUCT_MEDIA,
          payload: productMedia,
     };
};

export const updateAdminProductMedia = (productMedia) => {
     return {
          type: UPDATE_ADMIN_PRODUCT_MEDIA,
          payload: productMedia,
     };
};

export const deleteAdminProductMedia = (productMediaId) => {
     return {
          type: DELETE_ADMIN_PRODUCT_MEDIA,
          payload: productMediaId,
     };
};

export const addAdminProductMediaRequest = (productId, productMedia) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_MEDIAS.replace(':id', productId), 'POST', productMedia)
          .then((response) => {
               if (response.status === 200) {
                    const newMedia = response.data.media;
                    dispatch(addAdminProductMedia(newMedia));
                    dispatch(setShowPopup());
                    toast.success('Created Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const updateAdminProductMediaRequest = (productId, productMedia) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_MEDIA.replace(':id', productId).replace(':mediaId', productMedia.id), 'PUT', productMedia)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(updateAdminProductMedia(response.data.media));
                    dispatch(setShowPopupDetail(null));
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const deleteAdminProductMediaRequest = (productId, productMediaId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_MEDIA.replace(':id', productId).replace(':mediaId', productMediaId), 'DELETE')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(deleteAdminProductMedia(productMediaId));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

// Product Instructor
export const addAdminProductInstructorLeader = (productInstructors) => {
     return {
          type: ADD_ADMIN_PRODUCT_INSTRUCTOR_LEADER,
          payload: productInstructors,
     };
};

export const addAdminProductInstructorRequest = (productId, productInstructor, nextDispatch) => (dispatch) => {
     const { setProductInstructors } = nextDispatch;
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_INSTRUCTORS.replace(':id', productId), 'POST', productInstructor)
          .then((response) => {
               if (response.status === 200) {
                    const updatedProductInstructors = response.data.length > 0 ? response.data : INSTRUCTOR_DEFAULT;
                    setProductInstructors(updatedProductInstructors);
                    // let newProductInstructorsLeader = [...updatedProductInstructors];
                    // newProductInstructorsLeader = newProductInstructorsLeader.filter((item) => item.isLeader === true);
                    dispatch(addAdminProductInstructorLeader(updatedProductInstructors));
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setIsWaitingOrder(false));
          });
};

export const updateAdminProductInstructorOrderRequest = (productId, item1, item2) => (dispatch) => {
     if (item1.id !== item2.id) {
          setIsWaitingOrder(true);
          callApi(API_SYSTEM_ADMIN_PRODUCT_INSTRUCTOR_ORDER.replace(':id', productId).replace(':instructorId', item1.id), 'PUT', {
               order: item1.order,
          })
               .then((response) => {
                    if (response.status === 200) {
                         toast.success('Update Successfully');
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => dispatch(setIsWaitingOrder(false)));
          callApi(API_SYSTEM_ADMIN_PRODUCT_INSTRUCTOR_ORDER.replace(':id', productId).replace(':instructorId', item2.id), 'PUT', {
               order: item2.order,
          }).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
               }
          });
     }
};

// Product Prerequisite
export const setAdminProductPrerequisite = (productPrerequisites) => {
     return {
          type: SET_ADMIN_PRODUCT_PREREQUISITE,
          payload: productPrerequisites,
     };
};

export const setAdminProductPrerequisiteRequest = (productId, productPrerequisite, nextDispatch) => (dispatch) => {
     const { prerequisiteDefault, setProductPrerequisite } = nextDispatch;
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PREREQUISITE.replace(':productId', productId), 'POST', productPrerequisite)
          .then((response) => {
               if (response.status === 200) {
                    const updatedProductPrerequisites = response.data.length > 0 ? response.data : prerequisiteDefault;
                    dispatch(setAdminProductPrerequisite(updatedProductPrerequisites));

                    const newPrerequisites = updatedProductPrerequisites.map((pre) => {
                         const newPrerequisite = {
                              ...pre,
                              criterion: pre.certificationLevel ? 'certificationLevel' : pre.prerequisiteId ? 'product' : '',
                         };

                         return newPrerequisite;
                    });

                    setProductPrerequisite(newPrerequisites);
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setIsWaitingOrder(false));
          });
};

// Lesson
export const addAdminLesson = (lesson) => {
     return {
          type: ADD_ADMIN_LESSON,
          payload: lesson,
     };
};

export const updateAdminLesson = (lesson) => {
     return {
          type: UPDATE_ADMIN_LESSON,
          payload: lesson,
     };
};

export const deleteAdminLesson = (lessonId) => {
     return {
          type: DELETE_ADMIN_LESSON,
          payload: lessonId,
     };
};

export const addAdminLessonRequest = (lesson) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_LESSONS, 'POST', lesson)
          .then((response) => {
               if (response.status === 200) {
                    const newLesson = response.data;
                    dispatch(addAdminLesson(newLesson));
                    dispatch(setShowPopup());
                    toast.success('Created Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const updateAdminLessonRequest = (lesson) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_LESSON.replace(':id', lesson.id), 'PUT', lesson)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(updateAdminLesson(response.data));
                    dispatch(setShowPopupDetail(null));
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const deleteAdminLessonRequest = (lessonId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_LESSON.replace(':id', lessonId), 'DELETE')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(deleteAdminLesson(lessonId));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const updateAdminLessonOrderRequest = (item1, item2) => (dispatch) => {
     dispatch(setIsWaitingOrder(true));
     callApi(API_SYSTEM_ADMIN_LESSON_ORDER_UP.replace(':id', item1.id), 'PUT', { order: item1.order })
          .then((response) => {
               if (response.status === 200) {
                    callApi(API_SYSTEM_ADMIN_LESSON_ORDER_DOWN.replace(':id', item2.id), 'PUT', { order: item2.order }).then((response) => {
                         if (response.status !== 200) {
                              toastError(response);
                         }
                    });
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaitingOrder(false)));
};

// Product Event
export const addAdminProductEvent = (productEvent) => {
     return {
          type: ADD_ADMIN_PRODUCT_EVENT,
          payload: productEvent,
     };
};

export const updateAdminProductEvent = (productEvent) => {
     return {
          type: UPDATE_ADMIN_PRODUCT_EVENT,
          payload: productEvent,
     };
};

export const deleteAdminProductEvent = (productEventId) => {
     return {
          type: DELETE_ADMIN_PRODUCT_EVENT,
          payload: productEventId,
     };
};

export const addAdminProductEventRequest = (productId, payload, setListFilter, fromSOWPayload) => (dispatch) => {
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENTS.replace(':id', productId), 'POST', payload)
          .then((response) => {
               if (setListFilter) {
                    setListFilter([]);
               }

               if (response.status === 200) {
                    const newProductEvent = response.data.event;
                    dispatch(addAdminProductEvent(newProductEvent));
                    dispatch(setShowPopup());

                    if (fromSOWPayload) {
                         const { fetchEventsForAssign, pagination, setShowCreate } = fromSOWPayload;

                         setShowCreate(false);
                         fetchEventsForAssign(pagination);
                    }

                    toast.success('Created Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const updateAdminProductEventRequest = (productId, productEvent, setListFilter) => (dispatch, getState) => {
     const productDetail = cloneDeep(getState().admin.productDetails);

     const eventIndex = productDetail?.events?.rows?.findIndex((event) => event.id === productEvent.id) ?? -1;

     if (eventIndex !== -1) {
          productDetail.events[eventIndex] = productEvent;
          dispatch(setAdminProductDetails(productDetail));
     }

     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENT.replace(':id', productId).replace(':eventId', productEvent.id), 'PUT', productEvent)
          .then((response) => {
               if (setListFilter) {
                    setListFilter([]);
               }

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(updateAdminProductEvent(response.data.event));
               dispatch(setShowPopupDetail(null));

               toast.success('Update successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const adminUpdateEventWithAssignOrgRequest =
     (productId, payload, setListFilter, setIsNotUseAnySeats, fromSOWPayload) => (dispatch, getState) => {
          const productDetail = cloneDeep(getState().admin.productDetails);

          const { productEvent } = payload;

          const eventIndex = productDetail?.events?.rows?.findIndex((event) => event.id === productEvent.id) ?? -1;

          if (eventIndex !== -1) {
               productDetail.events[eventIndex] = productEvent;
               dispatch(setAdminProductDetails(productDetail));
          }

          dispatch(setIsWaiting(true));

          callApi(API_SYSTEM_ADMIN_UPDATED_WITH_ASSIGN_ORGANIZATIONS.replace(':id', productId).replace(':eventId', productEvent.id), 'PUT', payload)
               .then((response) => {
                    if (setListFilter) {
                         setListFilter([]);
                    }

                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    const eventRes = response.data.event;

                    dispatch(updateAdminProductEvent(eventRes));
                    dispatch(setShowPopupDetail(null));
                    setIsNotUseAnySeats(eventRes.maxSeats === eventRes.remainingSeats);

                    if (fromSOWPayload) {
                         const { fetchEventsForAssign, pagination, setShowEdit } = fromSOWPayload;

                         setShowEdit(false);
                         fetchEventsForAssign(pagination);
                    }

                    toast.success('Update successfully');
               })
               .finally(() => {
                    dispatch(setIsWaiting(false));
               });
     };

export const deleteAdminProductEventRequest = (productId, productEventId, setListFilter) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENT.replace(':id', productId).replace(':eventId', productEventId), 'DELETE')
          .then((response) => {
               if (setListFilter) {
                    setListFilter([]);
               }

               if (response.status === 200) {
                    dispatch(deleteAdminProductEvent(productEventId));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const updateAdminProductEventOrderRequest = (productId, event1, event2) => (dispatch) => {
     dispatch(setIsWaitingOrder(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENT.replace(':id', productId).replace(':eventId', event1.id), 'PUT', event1).then((response) => {
          if (response.status !== 200) {
               toastError(response);
          }
          dispatch(setIsWaitingOrder(false));
     });
     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENT.replace(':id', productId).replace(':eventId', event2.id), 'PUT', event2).then((response) => {
          if (response.status !== 200) {
               toastError(response);
          }
          dispatch(setIsWaitingOrder(false));
     });
};

export const updateEventConfirmAttendeesRequest = (productId, eventId, confirmAttendees, setListFilter) => (dispatch) => {
     dispatch(setIsWaiting(true));

     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENT_CONFIRM_ATTENDEES.replace(':id', productId).replace(':eventId', eventId), 'PUT', confirmAttendees)
          .then((response) => {
               if (setListFilter) {
                    setListFilter([]);
               }

               if (response.status === 200) {
                    dispatch(updateAdminProductEvent(response.data));
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowEditPopup(null));
          });
};

// Product FAQ
export const addAdminProductFaq = (productFaq) => {
     return {
          type: ADD_ADMIN_PRODUCT_FAQ,
          payload: productFaq,
     };
};

export const updateAdminProductFaq = (productFaq) => {
     return {
          type: UPDATE_ADMIN_PRODUCT_FAQ,
          payload: productFaq,
     };
};

export const deleteAdminProductFaq = (productFaqId) => {
     return {
          type: DELETE_ADMIN_PRODUCT_FAQ,
          payload: productFaqId,
     };
};

export const updateAdminProductFaqOrderRequest = (item1, item2, nextDispatch) => (dispatch) => {
     const { setIsWaitingOrder } = nextDispatch;
     setIsWaitingOrder(true);
     callApi(API_SYSTEM_ADMIN_PRODUCT_FAQ_ORDER_UP.replace(':id', item1.id), 'PUT', { order: item1.order })
          .then((response) => {
               if (response.status === 200) {
                    callApi(API_SYSTEM_ADMIN_PRODUCT_FAQ_ORDER_DOWN.replace(':id', item2.id), 'PUT', { order: item2.order }).then((response) => {
                         if (response.status !== 200) {
                              toastError(response);
                         }
                         toast.success('Update Successfully');
                    });
               } else {
                    toastError(response);
               }
          })
          .finally(() => setIsWaitingOrder(false));
};

export const addAdminProductFaqRequest = (productFaq) => (dispatch, getState) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_FAQS, 'POST', productFaq)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(addAdminProductFaq(response.data));
                    dispatch(setShowPopup());
                    toast.success('Created Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const updateAdminProductFaqRequest = (productFaq) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_FAQ.replace(':id', productFaq.id), 'PUT', productFaq)
          .then((response) => {
               if (response.status === 200) {
                    dispatch(updateAdminProductFaq(response.data));
                    dispatch(setShowPopupDetail(null));
                    toast.success('Update Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsWaiting(false)));
};

export const deleteAdminProductFaqRequest = (productFaqId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_FAQ.replace(':id', productFaqId), 'DELETE')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(deleteAdminProductFaq(productFaqId));
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const cloneTrainingEvent = (productId, id) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_PRODUCT_EVENT_CLONE.replace(':id', productId).replace(':eventId', id), 'POST')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(addAdminProductEvent(response.data));
                    toast.success('Clone Event Successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
          });
};
